/**
 * @generated SignedSource<<5de92ed6f2423b7802649e0b459020d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionSecondChanceOffer_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_item" | "PdpSharedPurchaseButton_item" | "PriceDisplay_item">;
  readonly " $fragmentType": "PdpSharedAuctionSecondChanceOffer_item";
};
export type PdpSharedAuctionSecondChanceOffer_item$key = {
  readonly " $data"?: PdpSharedAuctionSecondChanceOffer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionSecondChanceOffer_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionSecondChanceOffer_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "4010655472b0112e5e204aaff966540d";

export default node;
